(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["catcabin-cart-upsells"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('catcabin-cart-upsells')) {
  class CatcabinCartUpsells extends HTMLElement {
    connectedCallback() {
      this.handleClick = this.handleClick.bind(this);
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }

    async handleClick(event) {
      const button = event.target.closest('[data-catcabin-upsell-add]');
      if (!button || button.disabled) return;

      const originalLabel = button.dataset.label || button.textContent.trim();
      const errorElement = this.querySelector('.catcabin-cart-upsells__error');

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = this.dataset.loadingText;

      if (errorElement) {
        errorElement.hidden = true;
        errorElement.textContent = '';
      }

      try {
        const response = await fetch(this.dataset.cartAddUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(button.dataset.variantId),
                quantity: 1,
              },
            ],
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname,
          }),
        });

        const state = await response.json();

        if (!response.ok) {
          throw new Error(state.description || this.dataset.errorMessage);
        }

        const cartDrawer = document.querySelector('cart-drawer');

        if (cartDrawer && state.sections && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(state);
        } else {
          window.location.reload();
        }
      } catch (error) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = originalLabel;

        if (errorElement) {
          errorElement.textContent = error.message || this.dataset.errorMessage;
          errorElement.hidden = false;
        }
      }
    }
  }

  customElements.define('catcabin-cart-upsells', CatcabinCartUpsells);
}
  } catch(e) { console.error(e); }
})();

})();
